
export default {
  data: () => ({

    rawData:  [],
    
    chart: null,
    tube: null,
    base: null,
    title: null,
    actual: null,
    schedule: null,
    keys: null,
    
    canvasForms:  null,

  }),

  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },

  methods: {
    set_ColorDefs(){

      this.gmx_ColorH2Sets()
    }
  }

}